<template>
  <div class="cross-profile-table">
    <el-table
      :data="platforms"
      style="width: 100%; text-align: center"
      :border="true"
      max-height="600"
    >
      <el-table-column width="50" align="center">
        <template slot-scope="scope">
          <span>
            <SocialIcon :fontSize="'12px'" :type="channelIconList[scope.row.platform].name" />
          </span>
        </template>
      </el-table-column>

      <el-table-column
        :fixed="false"
        v-for="(column, index) in platforms"
        :label="channelIconList[column.platform].name"
        :key="index"
        width="50"
        align="center"
      >
        <template fixed slot="header">
          <SocialIcon :fontSize="'18px'" :type="channelIconList[column.platform].name" />
        </template>
        <template slot-scope="scope">
          <span>
            <cross-platform-engagement-cell-block
              :first_platform="column.platform"
              :second_platform="platforms[scope.$index].platform"
              :isCross="true"
              :percentage="platforms[scope.$index].engagement[column.platform]"
            ></cross-platform-engagement-cell-block>
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="uniques" label="Uniques">
        <template slot-scope="scope">
          <span>{{ formatUniquesNumber(scope) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="percentage" label min-width="120px">
        <template slot-scope="scope">
          <span>
            <el-progress
              :text-inside="true"
              :stroke-width="24"
              :color="'#6f7ad3'"
              :percentage="getLinePercentage(scope.row.uniques, totalUniques)"
            ></el-progress>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { round } from 'lodash';
import collect from 'collect.js';
import CrossPlatformEngagementCellBlock from '@/components/profiles/charts/CrossPlatformEngagementCellBlock';
import SocialIcon from '@/components/common/Icons/SocialIcon';
import EmailIcon from '@/components/common/Icons/EmailIcon';
import FbIcon from '@/components/common/Icons/FacebookIcon';
import InstagramIcon from '@/components/common/Icons/InstagramIcon';
import SmsIcon from '@/components/common/Icons/SmsIcon';
import TwitterIcon from '@/components/common/Icons/TwitterIcon';
import WhatsappIcon from '@/components/common/Icons/WhatsappIcon';
import TelegramIcon from '@/components/common/Icons/TelegramIcon';
import CellfindIcon from '@/components/common/Icons/CellfindIcon';
import MobileIcon from '@/components/common/Icons/MobileIcon';
import UssdIcon from '@/components/common/Icons/UssdIcon';
import WebhookIcon from '@/components/common/Icons/WebhookIcon';
import WechatIcon from '@/components/common/Icons/WechatIcon';
import SurveyIcon from '@/components/common/Icons/SurveyIcon';
import ChannelAppIcon from '@/components/common/Icons/ChannelAppIcon';
import ImportIcon from '@/components/common/Icons/ImportIcon';
import TiktokIcon from '@/components/common/Icons/TiktokIcon';

export default {
  name: 'CrossProfileTable',
  props: {
    profilesData: {
      type: Object,
      required: () => {},
    },
  },
  components: {
    CrossPlatformEngagementCellBlock,
    SocialIcon,
    EmailIcon,
    FbIcon,
    InstagramIcon,
    SmsIcon,
    TwitterIcon,
    WhatsappIcon,
    TelegramIcon,
    CellfindIcon,
    MobileIcon,
    UssdIcon,
    WebhookIcon,
    WechatIcon,
    SurveyIcon,
    ChannelAppIcon,
    ImportIcon,
    TiktokIcon,
  },
  data: () => ({
    channelIconList: {
      whatsapp: { name: 'WhatsApp', icon: WhatsappIcon },
      whatsapp_web: { name: 'WhatsApp', icon: WhatsappIcon },
      import: { name: 'Import', icon: ImportIcon },
      wechat: { name: 'WeChat', icon: WechatIcon },
      waboxapp: { name: 'Waboxapp', icon: ChannelAppIcon },
      twitter: { name: 'Twitter', icon: TwitterIcon },
      trumpia: { name: 'Trumpia', icon: ChannelAppIcon },
      telegram: { name: 'Telegram', icon: TelegramIcon },
      survey: { name: 'Survey', icon: SurveyIcon },
      sms: { name: 'SMS', icon: SmsIcon },
      instagram: { name: 'Instagram', icon: InstagramIcon },
      facebook: { name: 'Facebook', icon: FbIcon },
      email: { name: 'Email', icon: EmailIcon },
      dms: { name: 'Dms', icon: SmsIcon },
      cellfind: { name: 'CellFind', icon: CellfindIcon },
      mtech: { name: 'Mtech', icon: SmsIcon },
      default: { name: 'Default', icon: SmsIcon },
      infobip: { name: 'Infobip', icon: SmsIcon },
      ussd: { name: 'Ussd', icon: UssdIcon },
      mobile: { name: 'Mobile', icon: MobileIcon },
      webhook: { name: 'Web Hook', icon: WebhookIcon },
      tiktok: { name: 'TikTok', icon: TiktokIcon },
    },
  }),
  computed: {
    platforms() {
      return collect(collect(this.profilesData).toArray()).sortByDesc('uniques').all();
    },
    totalUniques() {
      return collect(this.platforms).sum('uniques');
    },
  },
  methods: {
    getChannelIconName(engagementChannels, channelIndex) {
      const channelKey = Object.keys(engagementChannels).sort()[channelIndex];
      const channelName = this.channelIconList[channelKey] || this.channelIconList.default;
      return channelName.name;
    },
    formatUniquesNumber(scope) {
      if (!scope) return 0;
      return new Intl.NumberFormat().format(scope.row.uniques);
    },
    getLinePercentage(platformUniques, totalUniques) {
      if (!totalUniques || isNaN(platformUniques)) return 0;
      const total = (platformUniques / totalUniques) * 100;
      return Math.min(100, Math.max(0, round(total)));
    },
  },
};
</script>
<style lang="scss" scoped>
.cross-profile-table {
  .el-table__body tr.hover-row > td,
  .el-table__body tr.hover-row.current-row > td,
  .el-table__body tr.hover-row.el-table__row--striped > td,
  .el-table__body tr.hover-row.el-table__row--striped.current-row > td {
    background: transparent !important;
  }
}
</style>



// WEBPACK FOOTER //
// CrossProfileTable.vue?49e174da